import React from 'react';
import { CloseIcon } from '../../../../../assets/icons/social/close.js';
import { popupSocialShareData } from '../utils';
import { updateBodyScroll } from '../../../../utils';

import './popup.m.css';

function popupSocialShareItem(url, icon, bgColor, text, alt, index) {
  return <li data-testid={text} key={`popup-item-${index}`}>
    <a href={url} target="_blank" styleName="social-wrapper">
      <span styleName="social-icon" style={{ backgroundColor: bgColor }}>
        { icon }
      </span>
      <span styleName="social-text">{text}</span>
    </a>
  </li>;
}

export class Popup extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    updateBodyScroll(true);
  }

  componentWillUnmount() {
    updateBodyScroll();
  }

  render() {
    const { fbUrl, twitterUrl, gplusUrl, linkedinUrl, whatsappUrl, grey, primaryColor = "#333", closePopup } = this.props;
    const popupItemsList = popupSocialShareData({ fbUrl, twitterUrl, gplusUrl, linkedinUrl, whatsappUrl});

    return <div styleName="share-popup-wrapper">
      <div styleName="share-popup">
        <div styleName="top-bar">
          <span styleName="share-text">Share it</span>
          <span styleName="close" onClick={closePopup}>
            <CloseIcon width="24" height="24" color={ grey ? "#333" : primaryColor } />
          </span>
        </div>
        <ul>
          {
            popupItemsList.map(({url, icon, bgColor, text, alt}, index) => popupSocialShareItem(url, icon, bgColor, text, alt, index))
          }
        </ul>
      </div>
    </div>;
  }
}